import { CellContext } from "@tanstack/react-table";
import styles from "./DifficultyCell.module.scss";
import { Dot } from "../../../ui/Icon/Icon";
import Tooltip from "../../../ui/Tooltip/Tooltip";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function DifficultyCell({ cell }: CellContext<any, number | null | undefined>) {
  const value = cell.getValue();

  if (typeof value !== "number") {
    return <Tooltip content="No data found">-</Tooltip>;
  }

  let className;

  if (value < 30) {
    className = styles.easy;
  } else if (value < 70) {
    className = styles.medium;
  } else {
    className = styles.hard;
  }

  return (
    <div className={styles.difficulty}>
      <Dot className={className} size="xxsmall" />
      <span>{value}</span>
    </div>
  );
}

export default DifficultyCell;
